
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ImagePreviewProps {
  imageUrl: string;
  onReset: () => void;
}

const ImagePreview = ({ imageUrl, onReset }: ImagePreviewProps) => {
  return (
    <div className="relative">
      <img
        src={imageUrl}
        alt="Preview"
        className="w-full h-[50vh] object-contain bg-gray-50"
      />
      <Button
        variant="outline"
        size="icon"
        className="absolute top-3 right-3 bg-white/80 backdrop-blur-sm hover:bg-white border-gray-200 text-gray-700 rounded-full h-9 w-9 shadow-md"
        onClick={onReset}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ImagePreview;
